// Phase 16.2 — Public/shell `<Brand />` now renders the official Lifted At The
// Moment artwork (via the Brand Asset Library) instead of the generic atomic
// orbit icon + text. Keeps the existing API (`compact` toggle, `to` link).

import React from "react";
import { Link } from "react-router-dom";
import { SHELL } from "@/constants/testIds";
import BrandMark from "@/components/lifted/BrandMark";

export default function Brand({ to = "/dashboard", compact = false }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center group"
      data-testid={SHELL.brand}
    >
      <BrandMark
        tag="logo.latm.primary"
        size={compact ? "sm" : "md"}
        className="transition-transform group-hover:scale-[1.02]"
      />
    </Link>
  );
}
